import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const ProductCard = ({ product, stockInfo }) => {
  const isOutOfStock = stockInfo
    ? !(stockInfo.in_stock ?? true)
    : (product.outOfStock || false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="block">
        <div className="relative overflow-hidden mb-6 aspect-square flex items-center justify-center bg-white p-8" style={{ borderRadius: '1rem' }}>
          <motion.img
            src={product.image}
            alt={product.name}
            className={`max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-105 ${isOutOfStock ? 'opacity-50' : ''}`}
            style={{ filter: product.imageFilter }}
            loading="lazy"
          />
          {isOutOfStock && (
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="bg-foreground/80 text-white px-6 py-2 rounded-full text-sm font-bold uppercase tracking-wider">Sold Out</span>
            </div>
          )}
        </div>
        <div className="space-y-2">
          <p className="text-sm uppercase tracking-wide text-muted-foreground">{product.origin}</p>
          <h3 className="text-2xl md:text-3xl font-semibold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {product.name}
          </h3>
          <p className="text-base md:text-lg text-foreground/70 leading-relaxed">
            {product.tagline}
          </p>
          <div className="pt-4">
            <p className="text-xl font-semibold text-primary">
              ${product.price['500g'] || Object.values(product.price)[0]}
            </p>
            <motion.div
              className="flex items-center space-x-2 text-primary group-hover:translate-x-1 transition-transform mt-2"
            >
              <span className="text-sm font-medium">View Details</span>
              <ArrowRight className="w-4 h-4" />
            </motion.div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
